/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NicknameAlreadyTakenDto
 */
export interface NicknameAlreadyTakenDto {
    /**
     * 
     * @type {boolean}
     * @memberof NicknameAlreadyTakenDto
     */
    nicknameAlreadyTaken: boolean;
}

export function NicknameAlreadyTakenDtoFromJSON(json: any): NicknameAlreadyTakenDto {
    return NicknameAlreadyTakenDtoFromJSONTyped(json, false);
}

export function NicknameAlreadyTakenDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NicknameAlreadyTakenDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'nicknameAlreadyTaken': json['nicknameAlreadyTaken'],
    };
}

export function NicknameAlreadyTakenDtoToJSON(value?: NicknameAlreadyTakenDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'nicknameAlreadyTaken': value.nicknameAlreadyTaken,
    };
}

